import { Environment } from 'common/enum'
import { getCodepipelineState } from 'api/Util'
import { checkEnvironment, sleep } from 'helpers/utils'
import React, { useCallback, useEffect, useState } from 'react'
import { Card, Grid } from '@material-ui/core'

export default function CodepipelineState () {
  const [result, setResult] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  const getState = useCallback(async () => {
    let count = 0
    const name = checkEnvironment(Environment.Production) ? 'fiton-api-production' : 'fiton-api-staging'

    while (true) {
      if (count >= 10000) {
        setIsLoading(true)
        break
      }

      setIsLoading(true)
      setResult(await getCodepipelineState(name))
      setIsLoading(false)

      await sleep(5000)

      count++
    }
  }, [])

  useEffect(() => {
    getState()
  }, [getState])

  const colorClassName = useCallback((status) => {
    if (status === 'Succeeded') return 'color-green'
    if (status === 'InProgress') return 'color-blue'
    return undefined
  }, [])

  return (
    <div className={'root'}>
      <Card className={'form-container'}>
        <h2>{isLoading ? 'loading...' : result.pipelineName}</h2>
        <br/>

        {
          result.stageStates?.map(state => {
            return (
              <div key={state?.stageName}>
                <Grid key={`${state?.stageName}-grid`} container>
                  <Grid key={`${state?.stageName}-grid-item-1`} item xs={4} />
                  <Grid key={`${state?.stageName}-grid-item-2`} item xs={2}>
                    <b>{state?.stageName}</b>
                  </Grid>
                  <Grid key={`${state?.stageName}-grid-item-3`} item xs={2}>
                    {
                      state?.actionStates?.map(action =>
                        <div key={`${action?.actionName}-status`} className={colorClassName(action?.latestExecution?.status)}>
                          {action?.latestExecution?.status}
                        </div>
                      )
                    }
                  </Grid>
                  <Grid item xs={4} />
                </Grid>
              </div>
            )
          })
        }
      </Card>
    </div>
  )
}
